<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20" />
    <el-row v-loading="isLoading" :element-loading-text="loadingText" type="flex" justify="space-between" :gutter="20" class="mr-t5">
      <el-col :span="24">
        <el-row :gutter="10">
          <el-col :span="spanInteger">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="120px" :rules="configRules">
                  <el-form-item label="장비명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="ipaddress" prop="dbmsIpaddress">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsIpaddress"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="DB 종류">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="objTypeList" option-key="basicinfoId, basicinfoSubid" property="basicinfoSubid" labelprop="basicinfoSubname" @change="dbTypeChange"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="제조사">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="filteredCompany" option-key="objCompanyId" property="objCompanyId" labelprop="objCompanyName"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="DB버전">
                    <w-select-form search="true" :modifiable="modifiable" :target="formData" :option-list="filteredProducts" option-key="objCompanyId, objProductId" property="objProductId" labelprop="objProductId"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="구동시간">
                    <w-text-form :modifiable="false" :target="formData" property="dbmsUptime" use-slot="true">
                      <span slot="data"> {{ convertDate(formData.dbmsUptime) }} </span>
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-obj-importance-form-editor :modifiable="modifiable" :target="formData" property="objImportance"> </w-obj-importance-form-editor>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMajor) }} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMinor) }} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="SSH ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserId1"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="SSH Password">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserPw1" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="SSH Port">
                    <w-number-form :modifiable="modifiable" :target="formData" property="sshPort"> </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="spanInteger">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Database 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="SID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsService"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="서비스 이름">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsAlias"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="사용자 ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsUserid"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsUserpw" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item :label="nodeParams.objtypeId == 'CUBRID' ? '브로커 번호' : '포트번호'">
                    <w-number-form :modifiable="modifiable" :target="formData" property="dbmsPort"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="에이전트 포트 번호" v-if="nodeParams.objtypeId == 'CUBRID'">
                    <w-number-form :modifiable="modifiable" :target="formData" property="dbmsAgentPort"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="운영체제" v-if="nodeParams.objtypeId == 'CUBRID'">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="osList" option-key="dbmsAgentOs, label" property="dbmsAgentOs" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="Lock 최대 개수">
                    <w-number-form :modifiable="modifiable" :target="formData" property="dbmsLockMaxCount"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="세션 최대 개수">
                    <w-number-form :modifiable="modifiable" :target="formData" property="dbmsSessionMaxCount"> </w-number-form>
                  </el-form-item>
                  <el-form-item v-if="nodeParams.objtypeId === 'ORACLE'">
                    <span slot="label">
                      Init Environment Path
                      <el-tooltip placement="bottom">
                        <i class="el-icon-info" />
                        <div slot="content">
                          <ul>
                            <li>ORACLE_HOME 환경변수가 설정되어 있는 파일의 Full Path</li>
                            <li>예)/home/oracle/.bash_profile</li>
                          </ul>
                        </div>
                      </el-tooltip>
                    </span>
                    <w-text-form :modifiable="modifiable" :target="formData" property="initEnvironmentPath"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
              <span v-if="nodeParams.objtypeId === 'ORACLE'" style="display:flex;">
                <el-form class="list form-list" :model="formData" label-width="120px">
                  <el-form-item label="Listener Alias">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsListener"> </w-text-form>
                  </el-form-item>
                </el-form>
                <div style="display:flex; align-items:center;">
                  <el-button @click="clickCheckListener">리스너 감지기</el-button>
                </div>
              </span>
              <div class="list form-list" v-if="nodeParams.objtypeId === 'ORACLE'">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="VIP Name">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsVipname"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="VIP Host">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dbmsViphost"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Application Link 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="Link">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkWwwUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Application">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkAppPath"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag"> </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="spanInteger" v-if="dynamicInfo.length > 0 && dynamicInfo !== null">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기타 정보</div>
              <div class="list form-list">
                <el-form ref="dbmsInfoDetailForm" :model="formData" label-width="120px">
                  <el-form-item v-for="field in dynamicInfo" v-if="!field.isText" :key="field.id" :label="field.label">
                    <div v-if="field.isText" v-html="getValueAfterCheckEmpty(field.value)"></div>
                    <span v-else class="h100 w100"> {{ getValueAfterCheckEmpty(field.value) }} </span>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row v-loading="isLoading" :element-loading-text="loadingText" type="flex" justify="space-between" :gutter="20">
      <el-col :span="24">
        <el-row :gutter="10" v-if="textFieldList.length > 0 && textFieldList !== null">
          <el-col :span="8" v-for="item in textFieldList" :key="item.id">
            <div class="list form-list">
              <el-form :model="formData" label-width="120px">
                <el-form-item :label="item.label">
                  <div v-html="getValueAfterCheckEmpty(item.value)"></div>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, assign, has, isEmpty } from 'lodash';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import MsgUtil from '@/utils/message';
// api
import dbInfoAPI from '@/api/config/database/database-info';
import commonAPI from '@/api/config/common';
// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import WCheckgroupForm from '@/components/formeditor/CheckGroupFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import wManagerTreeForm from '@/components/formeditor/MgrTreeSelectEditor';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';

const iptypeList = [
  {
    label: 'IPv4',
    ipaddressApplytype: 'IPv4',
  },
  {
    label: 'IPv6',
    ipaddressApplytype: 'IPv6',
  },
];

const connetTypeList = [
  {
    label: 'SSH',
    useSSH: true,
  },
  {
    label: 'Telnet',
    useSSH: false,
  },
];

export default {
  name: 'w-config-status',
  components: {
    dbInfoAPI,
    WTextForm,
    WNumberForm,
    WSelectForm,
    WCheckgroupForm,
    WCheckForm,
    wManagerTreeForm,
    WObjImportanceFormEditor,
  },
  props: {
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      spanInteger: 12,
      textFieldList: [],
      isLoading: true,
      loadingText: null,
      false: false,
      iptypeList,
      connetTypeList,
      objOriginData: {}, // Reject데이터
      formData: {}, // Form 바인딩 데이터
      managerList: [],
      objCompanyList: [],
      objTypeList: [],
      objProductList: [],
      dynamicInfo: [],
      basicDataLoadFlag: false,
      osList: [
        {
          dbmsAgentOs: 'WINDOWS',
          label: 'Windows',
        },
        {
          dbmsAgentOs: 'LINUX',
          label: 'linux',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['configRules', 'rejectConfigEditing', 'saveConfigEditing']),
    params() {
      return {
        objId: this.nodeParams.objId,
        objtypeId: this.nodeParams.objtypeId,
      };
    },
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    filteredCompany() {
      if (!isNil(this.filteredProducts) && this.filteredProducts.length > 0) {
        const companyId = this.filteredProducts[0].objCompanyId;
        return this.objCompanyList.filter((c) => c.objCompanyId === companyId);
      }
      return [];
    },
    filteredProducts() {
      return this.objProductList.filter((c) => c.objtypeId === this.formData.basicinfoSubid);
    },
  },
  watch: {
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        if (this.params.objId) {
          this.loadData();
        }
      },
    },
    filteredProducts() {
      if (!isNil(this.filteredProducts) && this.filteredProducts.length > 0) {
        const companyId = this.filteredProducts[0].objCompanyId;
        this.formData.objCompanyId = companyId;
      }
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.formData = Object.assign({}, this.objOriginData);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;
                  const updateDate = {
                    objId: infoParams.objId,
                    objName: infoParams.objName,
                    ipaddressApplytype: infoParams.ipaddressApplytype,
                    objCompanyId: infoParams.objCompanyId,
                    dbmsId: infoParams.dbmsId,
                    objImportance: formData.objImportance, // null이면 delete로 판단하므로 값 변경이 없을 경우에도 서버단에 전달한다.
                  };
                  if (infoParams.ipaddressApplytype === 'IPv4') {
                    updateDate.ipaddressIpv4 = infoParams.ipaddressIpv4;
                  } else if (infoParams.ipaddressApplytype === 'IPv6') {
                    updateDate.ipaddressIpv6 = infoParams.ipaddressIpv4;
                  }

                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      const prop = key === 'basicinfoSubid' ? 'objtypeId' : key;
                      updateDate[prop] = formData[prop];
                    });
                  }

                  if (this.objOriginData.objManagerIdMajor !== formData.objManagerIdMajor) {
                    updateDate.objManagerIdMajor = formData.objManagerIdMajor;
                  }

                  if (this.objOriginData.objManagerIdMinor !== formData.objManagerIdMinor) {
                    updateDate.objManagerIdMinor = formData.objManagerIdMinor;
                  }

                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  const encryptTargetData = createEncryptTargetData(updateDate, ['telnetuserPw1', 'dbmsUserpw']);
                  if (encryptTargetData !== null) {
                    getRsaEncrypt(encryptTargetData)
                      .then((encryptData) => {
                        this.saveConfig(assign(updateDate, encryptData), action, target);
                      })
                      .catch((e) => {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                        throw new Error(e);
                      });
                  } else {
                    this.saveConfig(updateDate, action, target);
                  }
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    getDateToString,
    convertValuByUnit,
    loadData() {
      if (!this.basicDataLoadFlag) {
        this.setBasicData();
      }
      this.objOriginData = {};
      this.isLoading = true;
      dbInfoAPI
        .getDbConfigInfoBasic(this.params)
        .then((result) => {
          if (result.data.success) {
            const data = result.data.data;

            if (data && !has(data, 'objCompanyId')) {
              // companyId 별로 모델을 필터링하는데
              // 처음부터 objCompanyId가 없을경우 computed watch 에서 catch못함
              data.objCompanyId = null;
            }

            if (data && !has(data, 'objtypeId')) {
              data.basicinfoSubid = null;
            } else {
              data.basicinfoSubid = data.objtypeId;
            }

            if (isNil(data.dbmsInfoDetailList)) {
              this.spanInteger = 12;
            } else {
              this.spanInteger = 8;
            }

            if (!isNil(data.dbmsInfoDetailList) && data.dbmsInfoDetailList.length > 0) {
              const dynamicInfo = [];

              data.dbmsInfoDetailList.forEach((field) => {
                dynamicInfo.push({
                  id: field.configId,
                  label: field.configName,
                  value: field.configValue,
                  isText: field.isText,
                });
              });

              this.dynamicInfo = dynamicInfo;

              const textFieldList = [];
              this.dynamicInfo.forEach((item) => {
                if (item.isText) {
                  textFieldList.push(item);
                }
              });
              this.textFieldList = textFieldList;
            } else {
              this.dynamicInfo = [];
            }
            Object.assign(this.objOriginData, data);
            this.formData = Object.assign({}, this.objOriginData);
            this.$emit('setConfigData', this.formData);
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '구성 정보', false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '구성 정보', false));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * 구성 정보를 저장한다.
     * @author Ju
     * @param  {[type]} updateDate [description]
     * @param  {[type]} action     [description]
     * @param  {[type]} target     [description]
     * @return {[type]}            [description]
     */
    saveConfig(updateDate, action, target) {
      dbInfoAPI
        .updateDbConfigInfo(updateDate)
        .then((result) => {
          if (result.data.success) {
            this.$message(MsgUtil.getResultMsgData(action, target, true));
            this.$store.dispatch('endConfigEdit');
            this.loadData();
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
        });
    },
    convertDate(value) {
      return isNil(value) ? EMPTY_TEXT : getDateToString(value);
    },
    dbTypeChange(value) {
      this.formData.objtypeId = value;
      this.formData.objProductId = null;
    },
    setBasicData() {
      dbInfoAPI.getDatabaseTypeList().then((res) => {
        this.objTypeList = res.data.data;
      });
      commonAPI.getObjProductList().then((res) => {
        this.objProductList = res.data.data;
      });
      commonAPI.getObjCompanyListHavingModel().then((res) => {
        this.objCompanyList = res.data.data;
      });
      commonAPI.getMgrInfoList().then((res) => {
        this.managerList = res.data.data;
      });
      this.basicDataLoadFlag = true;
    },
    clickCheckListener() {
      const formData = this.formData;
      const infoParams = Object.assign({}, formData);
      const params = {
        objId: infoParams.objId,
        telnetuserId1: infoParams.telnetuserId1,
        dbmsService: infoParams.dbmsService,
      };
      this.loadingText = '리스너 감지 수행 중..';
      this.isLoading = true;
      dbInfoAPI
        .getListenerFromOracleAccessInfo(params)
        .then((response) => {
          const result = response.data;
          if (result.success) {
            if (!isEmpty(result.data.message) || !isNil(result.data.message)) {
              this.$message(MsgUtil.getCustomMsgData(result.data.message));
            } else {
              this.$message(MsgUtil.getCustomMsgData('리스너 감지에 성공하였습니다.'));
            }
          } else {
            this.$message(MsgUtil.getCustomMsgData('리스너 감지에 실패하였습니다.'));
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.loadingText = null;
        });
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: #8b8b8b;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/database/configstatus/index.vue